import React, { useState } from 'react'
import {
  AppBar,
  Toolbar,
  Grid,
  Button,
  SwipeableDrawer,
  Avatar,
  Menu,
  MenuItem,
  styled
} from '@mui/material'
import useScrollTrigger from '@mui/material/useScrollTrigger'
import { useTheme } from '@mui/styles'
import { Link, useHistory } from 'react-router-dom'
import logo from '../../assets/logo.png'
import useMediaQuery from '@mui/material/useMediaQuery'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu';

const StyledImage = styled('img')({
  height: '4em',
  background: 'transparent',
  color: 'white',
})

const LogoButton = styled(Button)({
  padding: 0,
  '&:hover': {
    backgroundColor: 'transparent',
  },
})

const StyledIconButton = styled(IconButton)({
  marginLeft: 'auto',
  '&:hover': {
    backgroundColor: 'transparent',
  },
})

const StyledMenuIcon = styled(MenuIcon)({
  height: '50px',
  width: '50px',
  color: '#2f1700',
})

const StyledSwipeableDrawer = styled(SwipeableDrawer)(({ theme }) => ({
  paddingTop: '10em',
}))

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 1,
  backgroundColor: 'white',
  [theme.breakpoints.up('xs')]: {
    padding: '0 1em'
  },
  [theme.breakpoints.up('md')]: {
    padding: '0 5em'
  },
}))

const StyledMenu = styled(Menu)(({ theme }) => ({
  backgroundColor: theme.palette.common.blue,
  color: 'white',
  borderRadius: '0px',
}))

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  color: '#555',
  '&:hover': {
    opacity: 1.5,
    color: '#555',
  }
}))

const DrawerContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  minHeight: '100vh',
  paddingTop: '7em'
}))

function ElevationScroll(props) {
  const { children } = props

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  })

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  })
}

const StudentLoggedInNav = ({
  user,
  profile,
  logout,
  cldStudentImageAvatar,
}) => {
  const [openDrawer, setOpenDrawer] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const history = useHistory()
  const theme = useTheme()
  const matchesSM = useMediaQuery(theme.breakpoints.up('sm'))
  const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent)

  const handleClose = () => {
    setAnchorEl(null)
  }

  const onMouseOverHandler = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const onClickLogOutDrawerHandler = () => {
    logout()
    setOpenDrawer(false)
  }

  const onClickLessonsManagerDrawerHandler = () => {
    history.push('/students/lessons-manager')
    setOpenDrawer(false)
  }

  const logoutHandler = () => {
    logout()
    setAnchorEl(null)
    history.push('/')
  }

  const onClickContacUsDrawerHandler = () => {
    history.push('/contact-us')
    setOpenDrawer(false)
  }

  const onClickFindATeacherDrawerHandler = () => {
    history.push('/teachers/english')
    setOpenDrawer(false)
  }

  const tabsStudentLoggedIn = (
    <Grid item container alignItems="center">
      {user && user.role !== 'teacher' && (
        <Grid item>
          <Button
            component={Link}
            to="/teachers/english"
            variant="text"
            style={{
              textTransform: 'none',
              marginRight: '1.5em',
              color: '#333'
            }}
          >
            Tìm một giáo viên
          </Button>
        </Grid>
      )}

      {user && user.role !== 'teacher' && (
        <Grid item>
          <Button
            component={Link}
            to="/students/lessons-manager"
            variant="text"
            style={{
              textTransform: 'none',
              marginRight: '1.5em',
              color: '#333'
            }}
          >
            Quản lý bài học
          </Button>
        </Grid>
      )}

      <Grid item>
        <Button
          aria-controls="simple-menu"
          aria-haspopup="true"
          onMouseOver={onMouseOverHandler}
        >
          <Avatar
            style={{ width: '3em', height: '3em', borderRadius: '50%' }}
            src={
              user &&
              profile &&
              cldStudentImageAvatar &&
              user.role === 'user' &&
              cldStudentImageAvatar
            }
            alt="user-avatar"
          />
        </Button>
        <StyledMenu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          MenuListProps={{
            onMouseLeave: handleClose,
          }}
          elevation={0}
          style={{ zIndex: 1302 }}
        >
          {user && user.role !== 'teacher' && (
            <StyledMenuItem
              component={Link}
              onClick={handleClose}
              to="/students/lessons-manager"
            >
              Quản lý bài học
            </StyledMenuItem>
          )}
          <StyledMenuItem
            onClick={logoutHandler}
          >
            {user && user.role !== 'teacher' && 'Đăng xuất'}
          </StyledMenuItem>
        </StyledMenu>
      </Grid>
    </Grid>
  )

  const drawer = (
    <>
      <StyledSwipeableDrawer
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        onOpen={() => setOpenDrawer(true)}
        style={{ width: '14em', color: '#555' }}
      >
        <DrawerContainer
          container
          direction="column"
          alignItems="flex-end"
          style={{ width: '14em' }}
        >
          <Grid item>
            <Button
              onClick={onClickFindATeacherDrawerHandler}
              style={{
                color: 'white',
                textTransform: 'none',
                marginRight: '1.5em',
              }}
              variant="text"
            >
              Tìm một giáo viên
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="text"
              onClick={onClickLessonsManagerDrawerHandler}
              style={{
                color: 'white',
                textTransform: 'none',
                marginRight: '1.5em',
              }}
            >
              Quản lý bài học
            </Button>
          </Grid>

          <Grid item>
            <Button
              variant="text"
              onClick={onClickContacUsDrawerHandler}
              style={{
                color: 'white',
                textTransform: 'none',
                marginRight: '1.5em',
              }}
            >
              Liên hệ
            </Button>
          </Grid>

          <Grid item>
            <Button
              variant="text"
              onClick={onClickLogOutDrawerHandler}
              style={{
                color: 'white',
                textTransform: 'none',
                marginRight: '1.5em',
              }}
            >
              Thoát
            </Button>
          </Grid>
        </DrawerContainer>
      </StyledSwipeableDrawer>
      <StyledIconButton
        onClick={() => setOpenDrawer(!openDrawer)}
        disableRipple
        size="large">
        <StyledMenuIcon />
      </StyledIconButton>
    </>
  )

  return (
    <ElevationScroll>
      <StyledAppBar position="fixed">
        <Toolbar variant="dense" disableGutters>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <LogoButton
                component={Link}
                to="/"
                disableRipple
              >
                {logo && (
                  <StyledImage alt="company-logo" src={logo} />
                )}
              </LogoButton>
            </Grid>
            <Grid item>{matchesSM ? tabsStudentLoggedIn : drawer}</Grid>
          </Grid>
        </Toolbar>
      </StyledAppBar>
    </ElevationScroll>
  );
}

export default StudentLoggedInNav
